import {
  Component,
  Input,
  OnInit,

} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css'],
})
export class FileUploadComponent implements OnInit {
  @Input() control: FormControl;
  @Input() description;
  @Input() fieldId;
  @Input() fieldRequired;

  //.doc, .docx,
  
  accept = '.pdf, image/*, .txt';

  constructor() {}

  ngOnInit(): void {
  }

}
